import axiosInstance from "./AxiosInstance";

// Update the getLeads function to properly send the request
// export function getLeads(pagination, pageid, status, search_by = "", search_keyword = "",sort_by = "",sort_order="") {
//   return axiosInstance.post("/lead/allLeads", {
//     pagination,
//     pageid,
//     status: "All",
//     search_by,
//     search_keyword,
//     sort_by,
//     sort_order
//   });
// }
export function getLeads(
  pagination,
  pageid,
  status = "All",
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("/lead/allLeads", {
    pagination,
    pageid,
    status,
    search_by,
    search_keyword,
    sort_by,
    sort_order
  });
}

export function getTelecallerlist() {
  return axiosInstance.post("/lead/telecallerList", {});
}

export function assignLeadsToTelecaller(payload) {
  return axiosInstance.post("/lead/leadAssigned", payload);
}

// leads
export function getLeadDetails(lead_id) {
  return axiosInstance.post("/lead/leadDetails", { lead_id });
}

export function createLead(formData) {
  return axiosInstance.post("/lead/addLead", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function addLeadMarriageInfo(marriageData) {
  return axiosInstance.post("/lead/addLeadMarriageInfo", marriageData);
}

export function addLeadAddressInfo(addressData) {
  return axiosInstance.post("/lead/addLeadAddressInfo", addressData);
}

export function addLeadOtherInfo(formData) {
  return axiosInstance.post("/lead/addLeadOtherInfo", formData);
}

export function updateLead(formData) {
  return axiosInstance.post("/lead/editLead", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function deleteLead(lead_id) {
  return axiosInstance.post("/lead/deleteLead", { lead_id });
}

export function updatePanchkarmaExplained(lead_id, panchkarma_explained) {
  return axiosInstance.post("/lead/updatePanchkarmaExplained", {
    lead_id,
    panchkarma_explained: panchkarma_explained ? "Yes" : "No",
  });
}

export const routeToServiceCallerService = (lead_id) => {
  return axiosInstance.post("/lead/routeToServicecaller", {lead_id});
};

// Update the formatLeads function to better handle the API response structure
export function formatLeads(responseData) {
  if (!responseData) return [];

  if (Array.isArray(responseData)) {
    return responseData.map((lead) => ({
      lead_id: lead.lead_id || lead._id || lead.id,
      lead_name: lead.full_name || "",
      lead_email: lead.email || "",
      lead_dob: lead.date_of_birth || "",
      lead_phone: lead.phone_no || "",
      lead_city: lead.city || "",
      lead_type: lead.lead_type || "-",
      telecaller_name: lead.telecaller_name || "-",  
      lead_status: lead.lead_status || "",
      is_converted: lead.is_converted || "Not Converted",
      diseases: Array.isArray(lead.diseases) ? lead.diseases : [],
      platform: lead.platform || "",
      created_time: lead.created_time || "",
      ad_name: lead.ad_name || "",
      lead_photo: lead.lead_photo,
      questionnaire_filled: lead.questionnaire_filled || "No", // ✅ add this line
      patient_id: lead.patient_id || null, 
      partnerDetails: lead.partnerDetails || null
    }));
  }

  const leads = [];
  for (const key in responseData) {
    if (responseData.hasOwnProperty(key)) {
      const lead = responseData[key];
      leads.push({
        lead_id: lead.lead_id || lead._id || lead.id || key,
        lead_name: lead.full_name || "",
        lead_email: lead.email || "",
        lead_dob: lead.date_of_birth || "",
        lead_phone: lead.phone_no || "",
        lead_status: lead.lead_status || "",
        lead_city: lead.city || "",
        lead_type: lead.lead_type,
        telecaller_name: lead.telecaller_name || "-", 

      
        is_converted: lead.is_converted || "Not Converted", 
        diseases: Array.isArray(lead.diseases) ? lead.diseases : [],
        platform: lead.platform || "",
        created_time: lead.created_time || "",
        ad_name: lead.ad_name || "",
        lead_photo: lead.lead_photo,
        questionnaire_filled: lead.questionnaire_filled || "No", // ✅ add this line
        patient_id: lead.patient_id || null, 
        partnerDetails: lead.partnerDetails || null
      });
    }
  }

  return leads;
}


export function formatTelecallers(data) {
  if (!Array.isArray(data)) return [];
  return data.map((item) => ({
    id: item.admin_id || item.id,
    name: item.admin_name || "",
    contactNo: item.admin_mobile || "",
  }));
}
